import React, { useEffect } from "react";
import Logo from '../../src/asset/images/logo.svg'
import Home from "../pages/home";
import Footer from "./footer";
const Header = () => {

    useEffect(() => {
// for header color change
        if (typeof window !== 'undefined') {
            let scrollpos = window.scrollY
            const header = document.querySelector("header")
            const header_height = header.offsetHeight
            const add_class_on_scroll = () => header.classList.add("headerColorChange")
            const remove_class_on_scroll = () => header.classList.remove("headerColorChange")
            window.addEventListener('scroll', function () {
                scrollpos = window.scrollY;
                if (scrollpos >= header_height) add_class_on_scroll()
                else remove_class_on_scroll()
            })
        }
    }, [])
    return (
        <>
            <header className="sticky-top">
                <nav className="navbar navbar-expand-lg py-2">
                    <div className="container">
                        <a className="navbar-brand" href="#"><img src={Logo} alt="img" /></a>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav align-items-center align-items-sm-start gap-4 ms-auto my-3 ">
                                <li className="nav-item">
                                    <a className="nav-link" href="#about">About App</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#features">Features</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </header>
            <Home/>
            <Footer/>
        </>
    )
}
export default Header